import { Directive, ElementRef, HostBinding, Renderer2, OnDestroy, Input } from '@angular/core';
import { WindowRefService } from '../../services/window-ref-service';

@Directive({
    selector: '[fillComponentParentView]',
    standalone: false
})
export class FillComponentParentView implements OnDestroy {
  window: any;
  @HostBinding('style.height') height: string = '0px';
  public extraHeightViews: Array<any>;

  @Input('subtractViewHeight')
  set subtractView(subtractView: Array<any>) {
    this.extraHeightViews = subtractView;
    this.resizeHeight();
  }

  listener: Function;
  static parameters: any = [ElementRef, WindowRefService, Renderer2];
  constructor(private el: ElementRef, windowRef: WindowRefService, private renderer: Renderer2) {
    this.window = windowRef.nativeWindow;
    this.resizeHeight();
    this.listener = renderer.listen(this.window, 'resize', () => this.resizeHeight());
  }

  resizeHeight(): void {
    const { nativeElement }: any = this.el;
    const componentElement = new ElementRef(nativeElement.parentElement);
    this.getHeight(componentElement.nativeElement)
      .then((parentHeight: number) => {
        const extraHeight = (this.extraHeightViews || []).reduce((extra: number, view: any) => {
          if (!view) return extra;
          return extra + view.offsetHeight;
        }, 0);
        this.height = `${parentHeight - extraHeight}px`;
      });
  }

  getHeight(element: any): any {
    if (!element) return Promise.resolve();
    return new Promise((resolve: any): any => {
      if (element.parentElement) {
        const parentElement = new ElementRef(element.parentElement);
        const height = parentElement.nativeElement.offsetHeight;
        if (height) {
          resolve(parentElement.nativeElement.offsetHeight);
          return;
        }
        this.getHeight(parentElement.nativeElement).then((data: number) => resolve(data));
        return;
      }
      setTimeout(
        () => this.getHeight(element).then((data: number) => resolve(data)),
        100);
    });
  }

  ngOnDestroy(): void {
    this.listener();
    delete this.el;
    delete this.renderer;
    delete this.window;
    delete this.listener;
    delete this.height;
  }
}
